import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'

import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { intCol, numCol, strCol } from '@integec/grid-tools/lib/cols'
import moment from 'moment'
import Grid from '@integec/grid-tools/lib/Grid'
import {
  defaultVirtualizedCellRender,
  freeEditEngine,
  toSelectionColProps,
  VirtualizedCell,
  virtualizedGridRenderer,
} from '@integec/grid-tools'
import { connect } from 'react-redux'
import {
  getApiTargetInfo,
  getUnits,
  timeZoneIdentMap,
  ExportComponent,
} from 'core'

import R from 'ramda'
import { Button, Input, message, Modal, Select, Tooltip } from 'antd'
import {
  addRow,
  removeRow,
  // updateRow,
} from '@integec/grid-tools/lib/editEngine'
import { saveNonOutageSpill } from '../api/pgads'
import { ErrorContext, JcTmpErrorContext } from 'context'
import { isErrorContains } from '../core/component/JcTmpErrorDialog'
import { Filler } from 'core/screen-util'
import { rowHeaderRender } from 'core/utils'
import numeral from 'numeral'
const SpillNonOutageTable = ({
  isRetrieved = false,
  year,
  month,
  height = 250,
  width = 900,
  stationNameMap,

  data,
  targetInfo,
  selectedStation,
  spillCauseMap = {},
  factorList,
  eventStart,
  eventEnd,
  stationZoneMap,
  editInfo,
  setEditInfo,
  // eventStartZone
  retrieveData = _ => _,
  isEditPermission = false,
}) => {
  // const [validaion, setValidation] = useState([])

  const [spillRowSelection, setSpillRowSelection] = useState([])
  const [spillValidation, setSpillValidation] = useState([])
  const [selInsStation, setSelInsStation] = useState()
  const [selInsSpillType, setSelInsSpillType] = useState(1 + '')
  const { setError } = useContext(ErrorContext)
  const { setTmpError } = useContext(JcTmpErrorContext)
  const changeEditInfo = editInfo => {
    setEditInfo(editInfo)
  }

  useEffect(_ => setSelInsStation(), [selectedStation])

  const errorMessage = useCallback(
    data =>
      `( Station=${stationNameMap[data.station]}-${data.station}, Type=${
        spillCauseMap[data.spillType]
      }-${data.spillType}, Start=${data.spillStartMoment
        .tz(timeZoneIdentMap[stationZoneMap[data.station]])
        .format('MM/DD/YYYY HH:mm:ss')}, End=${data.spillEndMoment
        .tz(timeZoneIdentMap[stationZoneMap[data.station]])
        .format('MM/DD/YYYY HH:mm:ss')}, Flow Rate=${
        data.flowRate ? data.flowRate : 'NULL'
      }, eFactor=${data.overwriteFactor ? data.overwriteFactor : 'NULL'} )`,
    [spillCauseMap, stationNameMap, stationZoneMap]
  )

  useEffect(
    _ => {
      const spillDataAll = freeEditEngine.applyEdits({
        data: data || [],
        editInfo: editInfo || freeEditEngine.generateInitialEditInfo(),
      })

      const groupByStationArray = R.compose(
        // R.flatten,
        // R.map(staArr => checkValidationByStation(staArr)),
        R.map(([_, v]) => v),
        R.toPairs,
        R.groupBy(a => a.station)
      )(spillDataAll)

      const updateData = groupByStationArray.map(spillDataValidation =>
        spillDataValidation.map(d => {
          const eventStartZone = stationZoneMap[d.station]
          const spillStart = moment.tz(
            moment(d.spillStartMod, 'MM/DD/YYYY HH:mm').format(
              'YYYY-MM-DDTHH:mm:ss'
            ),
            timeZoneIdentMap[eventStartZone]
          )
          // .utc()

          const spillEnd = moment.tz(
            moment(d.spillEndMod, 'MM/DD/YYYY HH:mm').format(
              'YYYY-MM-DDTHH:mm:ss'
            ),
            timeZoneIdentMap[eventStartZone]
          )
          // .utc(d.spillEndMod, 'MM/DD/YYYY HH:mm')
          // .utc()
          return {
            ...d,
            spillStart: spillStart.format('YYYY-MM-DDTHH:mm:ss'),
            spillStartMoment: spillStart,
            spillEnd: spillEnd.format('YYYY-MM-DDTHH:mm:ss'),
            spillEndMoment: spillEnd,
          }
        })
      )

      const valError = []
      updateData.forEach(spillDataValidation =>
        spillDataValidation.forEach(valData => {
          const {
            // spillStart,
            // spillEnd,
            overwriteFactor,
            flowRate,
            // station,
            // spillType,
            spillStartMoment,
            spillEndMoment,
          } = valData
          const eventStartZone = stationZoneMap[valData.station]
          // const spillZoneDate = moment.tz(
          //   moment(spillStart),
          //   timeZoneIdentMap[eventStartZone]
          // )
          // const spillEndZoneDate = moment.tz(
          //   moment(spillEnd),
          //   timeZoneIdentMap[eventStartZone]
          // )

          const eventStartMoment = moment.tz(
            eventStart,
            timeZoneIdentMap[eventStartZone]
          )

          // const spillEndMoment = moment
          //   .utc(spillEnd)
          //   // .utc()
          //   .tz(timeZoneIdentMap[eventStartZone])
          const eventEndMoment = moment.tz(
            moment(eventEnd),
            timeZoneIdentMap[eventStartZone]
          )

          // .tz(timeZoneIdentMap[eventStartZone])
          if (spillStartMoment.isBefore(eventStartMoment))
            valError.push({
              text: 'Start must be within the selected month.',
              data: valData,
            })
          if (spillEndMoment.isAfter(eventEndMoment))
            valError.push({
              text: `End must be within the selected month.`,
              data: valData,
            })
          if (!spillStartMoment.isValid())
            valError.push({ text: 'Start is required Field.', data: valData })
          if (!spillEndMoment.isValid())
            valError.push({ text: 'End is required Field.', data: valData })
          if (isNaN(flowRate) || (flowRate + '').trim().length <= 0)
            valError.push({
              text: 'Flow Rate is required Field.',
              data: valData,
            })
          if (
            isNaN(overwriteFactor) ||
            (overwriteFactor + '').trim().length <= 0
          )
            valError.push({ text: 'eFactor is required Field.', data: valData })
          if (spillStartMoment.isAfter(spillEndMoment))
            valError.push({ text: 'Start cannot be after End.', data: valData })
          // const isStartUnder = eventStartMoment.isBetween(
          //   spillStartMoment.clone().subtract(1, 's'),
          //   spillEndMoment.clone().add(1, 's')
          // )

          // const isEndUnder = eventEndMoment.isBetween(
          //   spillStartMoment.clone().subtract(1, 's'),
          //   spillEndMoment.clone().add(1, 's')
          // )

          // if (!isStartUnder || !isEndUnder)
          //   // need to show conform dialog warning
          //   valError.push({
          //     text:
          //       'You are about to extend the spill entry beyond the start/end of its related outage.',
          //     data: valData,
          //   })
          // overlap validation
          spillDataValidation.forEach(outer => {
            const outerStart = moment(outer.spillStart)
            // const outerEnd = moment(outer.spillEnd)
            spillDataValidation.forEach(inner => {
              if (outer !== inner) {
                const innerStart = moment(inner.spillStart)
                const innerEnd = moment(inner.spillEnd)
                if (
                  outer.spillType === inner.spillType &&
                  (outerStart.isBetween(innerStart, innerEnd) ||
                    outerStart.isSame(innerStart))
                ) {
                  valError.push({
                    text:
                      'Spills of the same type may never overlap. Spills of different types may overlap.',
                    data: outer,
                  })
                }
              }
            })
          })
        })
      )

      // const isEqual = R.equals(spillValidation, valError)
      // if (!isEqual) {
      //   setSpillValidation(valError)
      // }
      setSpillValidation(valError)
    },
    [data, editInfo, eventEnd, eventStart, stationZoneMap]
  )

  // const [selectedRows, setSelectedRows] = useState({})
  const setSelectedRows = selection => {
    const isEqual = R.equals(spillRowSelection, selection.selectedRows)

    if (!isEqual) setSpillRowSelection(selection.selectedRows)
  }

  // const getFactorBySpillDate = (dateStr, stationId) => {
  //   const factor = factorList.find(f => {
  //     const eff = moment(f.effectiveDate)
  //     const dt = moment(dateStr)
  //     return dt.isSameOrAfter(eff) && (f.station || '') === (stationId || '')
  //   })
  //   return (factor && factor.conversionFactor) || undefined
  // }

  const getFactorBySpillDate = useCallback(
    (dateStr, stationId) => {
      const factor = (factorList || [])
        .filter(f => {
          const eff = moment(f.effectiveDate)
          const dt = moment(dateStr)
          return (
            dt.isSameOrAfter(eff) && (f.station || '') === (stationId || '')
          )
        })
        .map(d => ({ ...d, momEff: moment(d.effectiveDate) }))

      let latest = factor.length > 0 ? factor[0] : {}
      if (factor.length > 1) {
        const max = moment.max(factor.map(d => d.momEff))
        latest = factor.find(d => d.momEff.isSame(max))
      }

      return (latest && latest.conversionFactor) || undefined
    },
    [factorList]
  )

  // const getDurHr = (spillStartMod, spillEndMod) => {
  //   return spillEndMod && spillStartMod
  //     ? spillEndMod.diff(spillStartMod, 'H')
  //     : undefined
  // }

  const getDurHr = (spillStartMod, spillEndMod) => {
    if (spillEndMod && spillStartMod) {
      let diff = spillEndMod.diff(spillStartMod, 'm')
      if (diff !== 0 && !isNaN(diff)) {
        diff = diff / 60
        if (!isNaN(diff)) {
          return numeral(diff).format('#.00')
        }
      }
    }
    return undefined
  }

  const modifyDataForSave = data => {
    return data.map(d => {
      return {
        ...d,
        spillStart: moment
          .tz(
            moment(d.spillStartMod, 'MM/DD/YYYY HH:mm').format(
              'YYYY-MM-DDTHH:mm:ss'
            ),
            timeZoneIdentMap[stationZoneMap[d.station]]
          )
          .utc()
          .format('YYYY-MM-DDTHH:mm.ss'),
        spillEnd: moment
          .tz(
            moment(d.spillEndMod, 'MM/DD/YYYY HH:mm').format(
              'YYYY-MM-DDTHH:mm:ss'
            ),
            timeZoneIdentMap[stationZoneMap[d.station]]
          )
          .utc()
          .format('YYYY-MM-DDTHH:mm.ss'),
      }
    })
  }

  const removeSelectedRows = _ => {
    // if (spillRowSelection.length <= 0)
    //   return message.warning('Please Select Row')
    // deleteNonOutageSpill(targetInfo)(modifyDataForSave(spillRowSelection)).fork(
    //   setError,
    //   tmpError => {
    //     if (tmpError.length <= 0) {
    //       message.info('Data Saved')
    //       retrieveData()
    //     } else if (!isErrorContains(tmpError)) {
    //       message.info('Data Saved')
    //       retrieveData()
    //       setTmpError(tmpError)
    //     } else {
    //       setTmpError(tmpError)
    //     }
    //   }
    // )
    let effEditInfo = { ...editInfo }
    spillRowSelection.forEach(row => {
      effEditInfo = removeRow({ editInfo: effEditInfo, currentRow: row })
    })
    setEditInfo(effEditInfo)
  }

  const saveData = _ => {
    if (spillValidation.length > 0) {
      return message.warning('Please, correct all validation before Save')
    }
    let saveData = freeEditEngine.applyEdits({
      data: data,
      editInfo,
    })

    saveData = modifyDataForSave(saveData)
    if (saveData.length <= 0) {
      // only one recode and user Delete that record
      saveData = selectedStation.map(station => ({
        station,
        action: 'D',
        year,
        month,
      }))
    }
    saveNonOutageSpill(targetInfo)(saveData).fork(setError, tmpError => {
      if (tmpError.length <= 0) {
        message.info('Data Saved')
        retrieveData()
      } else if (!isErrorContains(tmpError)) {
        message.info('Data Saved')
        retrieveData()
        setTmpError(tmpError)
      } else {
        setTmpError(tmpError)
      }
    })
  }

  const insertSpill = _ => {
    if (!selInsStation) return message.warning('Please, Select Station')
    // const saveData = freeEditEngine.applyEdits({
    //   data: data,
    //   editInfo,
    // })

    const spillStart = eventStart
    const spillEnd = eventEnd
    const defaultFactor = getFactorBySpillDate(spillStart, selInsStation)
    const spillStartMod = moment(spillStart).format('MM/DD/YYYY HH:mm')
    const spillEndMod = spillEnd && moment(spillEnd).format('MM/DD/YYYY HH:mm')

    const newSpill = {
      year,
      month,
      station: selInsStation,
      defaultFactor,
      overwriteFactor: defaultFactor,
      spillStart,
      spillEnd,
      spillStartMod,
      spillEndMod,
      spillType: selInsSpillType,
      // durHr,
    }
    const nEditInfo = addRow({ editInfo, editedRow: newSpill })

    setEditInfo(nEditInfo)
  }

  const cellRender = props => {
    const { gridToolProps, reactVirtualizedProps } = props
    const { getCellProps, headers, data } = gridToolProps
    const { columnIndex, rowIndex, style } = reactVirtualizedProps

    const {
      defaultFactor,
      overwriteFactor,
      flowRate,
      // spillStart,      spillEnd,station,      spillType,
      spillEndMod,
      spillStartMod,
    } = data[rowIndex]
    const durHr = getDurHr(moment(spillStartMod), moment(spillEndMod))
    // const errorList = spillValidation.filter(valData =>
    //   R.equals(
    //     { station, spillEndMod, spillStartMod, spillType },
    //     {
    //       station: valData.data.station,
    //       // spillEnd: valData.data.spillEnd,
    //       // spillStart: valData.data.spillStart,
    //       spillEndMod,
    //       spillStartMod,
    //       spillType: valData.data.spillType,
    //     }
    //   )
    // )

    const headerIdent = headers[columnIndex].ident

    const cellProps = getCellProps({
      rowIndex,
      columnIndex,
      header: headers[columnIndex],
      data,
      style,
    })
    if (cellProps.isEditing) {
      return defaultVirtualizedCellRender({
        ...props,
      })
    }

    const overStyle = {
      ...style,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      borderTop: '1px solid #cc',
      backgroundColor: cellProps.isSelected ? '#F8F8F8' : 'white',
      color: cellProps.isSelected ? 'black' : undefined,
    }

    if (headerIdent === 'durHr') {
      //  if (flowRate && factor && durHr)
      // const mwhStyle = { ...overStyle, color: '#0000ff', fontWeight: '700' }
      return (
        <VirtualizedCell {...props} {...cellProps}>
          {isNaN(durHr) ? '' : durHr}
        </VirtualizedCell>
      )
    }
    if (headerIdent === 'overwriteFactor') {
      //  if (flowRate && factor && durHr)
      const factorStyle = {
        ...overStyle,
        color: overwriteFactor === defaultFactor ? overStyle.color : '#e53935',
        fontWeight: overwriteFactor === defaultFactor ? 'black' : '700',
      }

      return (
        <VirtualizedCell {...props} {...cellProps} style={factorStyle}>
          {overwriteFactor}
        </VirtualizedCell>
      )
    }
    if (headerIdent === 'mwh') {
      //  if (flowRate && factor && durHr)
      const mwhStyle = { ...overStyle, color: '#0000ff', fontWeight: '700' }
      const mwhValue = Number(flowRate * overwriteFactor * durHr).toFixed(2)
      return (
        <VirtualizedCell {...props} {...cellProps} style={mwhStyle}>
          {isNaN(mwhValue) ? '' : mwhValue}
        </VirtualizedCell>
      )
    }

    return defaultVirtualizedCellRender({
      ...props,
      style: overStyle,
    })

    // const style = reactVirtualizedProps.style
    // return (
    //   <Tooltip
    //     placement="bottomLeft"
    //     title={errorList.map(t => (
    //       <div key={t}>{t.text}</div>
    //     ))}
    //   >
    //     {defaultVirtualizedCellRender({
    //       ...props,
    //       style: overStyle,
    //     })}
    //   </Tooltip>
    // )
  }

  const getDataForExport = _ => {
    const modData = freeEditEngine.applyEdits({
      data: data,
      editInfo,
    })

    const finalExportData = modData.map(row => {
      const {
        // defaultFactor,
        overwriteFactor,
        flowRate,
        // spillStart,      spillEnd,station,      spillType,
        spillEndMod,
        spillStartMod,
      } = row

      const durHr = getDurHr(moment(spillStartMod), moment(spillEndMod))
      const mwhValue = Number(flowRate * overwriteFactor * durHr).toFixed(2)

      return { ...row, durHr, mwh: isNaN(mwhValue) ? '' : mwhValue }
    })

    return finalExportData
  }

  const showValidationModal = _ => {
    Modal.info({
      title: 'Spill Validation',
      style: { width: '800px' },
      bodyStyle: { width: '800px' },
      width: '700px',
      content: (
        <div style={{ maxHeight: '300px', overflow: 'auto' }}>
          <ol>
            {spillValidation.map(v => (
              <li key={v}>
                {v.text} {errorMessage(v.data)}
              </li>
            ))}
          </ol>
        </div>
      ),
      onOk() {},
    })
  }

  const headerWithFormatter = useMemo(
    _ =>
      SpillHeaders.map(header =>
        header.ident === 'station'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),
              dataFormatter: ({ value }) => stationNameMap[value] || value,
              sortIndexGetter: ({ rowData }) =>
                stationNameMap[rowData.station] || rowData.station,
              ...toSelectionColProps(stationNameMap),
            }
          : header.ident === 'spillType'
          ? {
              ...header,
              // ...toSelectionColProps(utilityNameMap),

              sortIndexGetter: ({ rowData }) =>
                spillCauseMap[rowData.spillType] || rowData.spillType,
              ...toSelectionColProps(spillCauseMap),
              dataFormatter: ({ value }) =>
                value ? spillCauseMap[value] + ' - ' + value : value,
            }
          : header
      ),
    [stationNameMap, spillCauseMap]
  )

  // eslint-disable-next-line no-unused-vars
  const processEditedRow = ({ currentRow, editedRow }) => {
    // { originalRow: currentRow, currentRow, editedRow }

    // updateRow({editInfo,currentRow, editedRow:row})

    // updateRow({ editInfo, editedRow: row })
    let isUpdatedFactor = false
    if (
      editedRow.defaultFactor &&
      editedRow.overwriteFactor &&
      parseFloat(editedRow.defaultFactor) ===
        parseFloat(editedRow.overwriteFactor)
    )
      isUpdatedFactor = false
    else isUpdatedFactor = true
    const defaultFactor = getFactorBySpillDate(
      moment(editedRow.spillStartMod, 'MM/DD/YYYY HH:mm'),
      selInsStation
    )
    const ud = {
      ...editedRow,
      defaultFactor,
      overwriteFactor: isUpdatedFactor
        ? editedRow.overwriteFactor
        : defaultFactor,
    }
    return ud
  }

  return (
    <div
      style={{
        height: height + 'px',
        width: width + 'px',
        display: 'grid',
        gridTemplateRows: 'min-content auto',
      }}
    >
      <div
        style={{
          width: '100%',
          gap: '10px',
          marginTop: '20px',
          marginBottom: '5px',
          display: isEditPermission ? 'grid' : 'none',
          gridTemplateColumns:
            '300px 200px min-content min-content 200px auto min-content 200px',
        }}
      >
        <Select
          disabled={!isRetrieved}
          value={selInsStation}
          onChange={sid => setSelInsStation(sid)}
          style={{ width: '100%' }}
        >
          {selectedStation.map(s => (
            <Select.Option key={s}>
              {stationNameMap[s]}-{s}
            </Select.Option>
          ))}
        </Select>
        <Select
          value={selInsSpillType}
          onChange={stype => setSelInsSpillType(stype)}
          style={{ width: '100%' }}
          disabled={!isRetrieved}
        >
          {Object.keys(spillCauseMap).map(k => (
            <Select.Option key={k + ''}>
              {spillCauseMap[k]}-{k}
            </Select.Option>
          ))}
        </Select>

        <Button
          onClick={insertSpill}
          type="primary"
          disabled={!isRetrieved}
          icon="plus-circle"
        >
          Add New Spill
        </Button>
        <Button
          icon="delete"
          onClick={removeSelectedRows}
          type="danger"
          disabled={!isRetrieved && spillRowSelection <= 0}
        >
          Remove Selected Spill Record(s)
        </Button>
        <Button
          onClick={saveData}
          disabled={!isRetrieved}
          type="primary"
          icon="save"
        >
          Save
        </Button>
        <Filler />

        <Tooltip title="View All Validation">
          <Button
            icon="eye"
            onClick={showValidationModal}
            disabled={spillValidation.length <= 0}
          >
            View All Validation
          </Button>
        </Tooltip>
        <ExportComponent
          getData={getDataForExport}
          data={data}
          headers={headerWithFormatter}
          fileName={`NonOutageSpill_${year}_${month}`}
          btnStyle={{ marginRight: '10px' }}
          disabled={data.length <= 0}
        />
        <Input
          disabled
          value={
            (spillValidation || []).length > 0
              ? spillValidation[0].text +
                ' ' +
                errorMessage(spillValidation[0].data)
              : undefined
          }
          style={{ gridColumnEnd: 'span 7' }}
          placeholder="First Validation shown here. Click on 'View All Validation' to view all validation in Modal "
        />
      </div>
      <Grid
        headers={headerWithFormatter}
        data={data}
        render={virtualizedGridRenderer({
          height: isEditPermission ? height : height + 100,
          width,
          cellRender,
          headerRowHeight: 30,
          rowHeaderRender,
        })}
        editInfo={editInfo}
        onEditInfoChange={changeEditInfo}
        isEditable={editable => {
          return (isEditPermission && editable.header.editable) || false
        }}
        editMode="cell"
        onSelectionChange={rows => {
          setSelectedRows(rows)
        }}
        selectionMode="single"
        selectionType="cell"
        sortOptions={headerWithFormatter}
        initialSortOptions={headerWithFormatter}
        processEditedRow={processEditedRow}
      />
    </div>
  )
}

const mapStateToProps = state => ({
  units: getUnits(state),
  targetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SpillNonOutageTable)

const SpillHeaders = [
  strCol({
    ident: 'station',
    display: 'Station',
    width: 250,
    isKey: true,
    sortOrder: 'asc',
    editable: false,
  }),
  // strCol({
  //   ident: 'unitId',
  //   display: 'unit',
  //   width: 100,
  //   isRequired: true,
  //   sortOrder: 'asc',
  // }),
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
    width: 50,
    editable: false,
    sortOrder: 'asc',
  }),
  intCol({
    ident: 'month',
    display: 'Month',
    isKey: true,
    width: 50,
    editable: false,
    sortOrder: 'asc',
  }),
  // intCol({
  //   ident: 'eventNum',
  //   display: 'Event Number',
  //   isKey: true,
  //   width: 60,
  // }),

  strCol({
    ident: 'spillType',
    display: 'Spill Type',
    width: 150,
    isKey: true,
    editable: false,
    sortOrder: 'asc',
    sortIndexGetter: ({ rowData }) => rowData.spillType,
  }),

  strCol({
    ident: 'spillStartMod',
    display: 'Start (mm/dd/yyyy hh:mm)',
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    editable: true,
    sortIndexGetter: ({ rowData }) => {
      const v = moment(rowData.spillStartMod, 'MM/DD/YYYY HH:mm').format(
        'YYYYMMDDHHmmss'
      )
      return v
    },
    sortOrder: 'asc',
  }),
  // strCol({
  //   ident: 'spillEnd',
  //   display: 'end',
  //   width: 200,
  //   isKey: true,
  // }),

  strCol({
    ident: 'spillEndMod',
    display: 'End (mm/dd/yyyy hh:mm)',
    width: 200,
    displayFormat: 'MM/DD/YYYY HH:mm',
    editable: true,
  }),

  numCol({
    ident: 'flowRate',
    display: 'Flow Rate/Hr',
    displayFormat: '0.0000',
    editable: true,
  }),
  numCol({
    // ident: 'defaultFactor',
    ident: 'overwriteFactor',
    display: 'eFactor',
    displayFormat: '0.0000',
    editable: true,
  }),
  numCol({
    ident: 'durHr',
    display: 'Duration Hours',
    displayFormat: '0.00',
    editable: false,
  }),
  numCol({ ident: 'mwh', display: 'MWH', editable: false }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 300,
    ellipsis: true,
    alignment: 'left',
  }),
  modifierCol,
  modifiedDateCol,
]
